
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"READERS"'></app-infrastructure-header>

<!-- Main Screen which shows the Readers and Reader Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#reader-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> READERS</a></li>
			<li class=""><a data-toggle="tab" href="#readers-tab" aria-expanded="false"><i class="fa fa-star-o"></i> READER TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Readers Tab -->
			<div id="readers-tab" class="tab-pane fade">

				<!-- Add Reader Type and Options buttons -->
				<button (click)="addReaderClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em>ADD READER TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<!-- OPTIONS - Drop Down Menu Button -->
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em class="fa fa-th"></em>OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<!-- EDIT -->
						<li (click)="editSelectedReaderClicked()" [class.disabled]="!isSingleReaderSelected()"><a><em class="fa fa-pencil"></em>&nbsp;EDIT</a></li>
						<!-- DUPLICATE -->
						<li (click)="duplicateSelectedReaderClicked()" [class.disabled]="!isSingleReaderSelected()"><a><em class="fa fa-clone"></em>&nbsp;DUPLICATE</a></li>
						<!-- DELETE -->
						<li (click)="deleteSelectedReadersClicked()" [class.disabled]="!isAnyReadersSelected()"><a><em class="fa fa-remove"></em>&nbsp;DELETE</a></li>
						<li class="divider"></li>
						<!-- ADD TO GROUP -->
						<li (click)="addSelectedReadersToGroupClicked()" [class.disabled]="!isAnyReadersSelected()"><a><em class="fa fa-plus"></em>&nbsp;ADD TO GROUP</a></li>
						<!-- REMOVE FROM GROUP -->
						<li (click)="removeSelectedReadersFromGroupClicked()" [class.disabled]="!isAnyReadersSelected()"><a><em class="fa fa-remove"></em>&nbsp;REMOVE FROM GROUP</a></li>
						<!-- MANAGE GROUPS -->
						<li (click)="manageReaderGroupsClicked()"><a><em class="fa fa-pencil"></em>&nbsp;MANAGE GROUPS</a></li>
						<li class="divider"></li>
						<!-- UPLOAD READERS -->
						<li (click)="uploadFileClicked()"><input type="file" #fileUpload (change)="onFileUploadChange($event)" style="display:none" /><a><em class="fa fa-pencil"></em>&nbsp;UPLOAD READERS</a></li>
						<!-- DOWNLOAD READERS -->
						<li (click)="downloadReaders()"><a><em class="fa fa-pencil"></em>DOWNLOAD READERS</a></li>

					</ul>
				</div>

				<!-- "Filter" Button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionsForTypes" (click)="onFilterOptionForTypesClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>
	
				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="filterOptionForTypes?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ filterOptionForTypes.label }}
				</div>
	
				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="filterOptionForTypes?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
						[(ngModel)]="filterValueForTypes"
						(ngModelChange)="onFilterValueForTypesChanged()">
				</div>
	
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>
	

				<!-- Readers -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllReadersSelected()"
										(change)="setAllReadersSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let reader of mReaders | paginate: {id: 'reader_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForTypes, totalItems: totalNumberOfTypes }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="reader.mSelected" /></td>
								<td (click)="editReader(reader.mReader)">{{reader.mReader.name}}</td>
								<td>
									<ng-container
										*ngIf="reader.mReader.groups != null && reader.mReader.groups.length > 0">
										<ng-container *ngFor="let group of reader.mReader.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Readers" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="reader_pagination" (pageChange)="onTypePageChange($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Reader Instances Tab -->
			<div id="reader-instances-tab" class="tab-pane fade active in">

				<!-- Add Reader and Options buttons -->
				<button (click)="addReaderInstanceClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em>&nbsp;ADD READER</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<!-- OPTIONS - Drop Down Menu Button -->
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em class="fa fa-th"></em>&nbsp;OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<!-- EDIT -->
						<li (click)="editSelectedReaderInstanceClicked()" [class.disabled]="!isSingleReaderInstanceSelected()"><a><em class="fa fa-pencil"></em>&nbsp;EDIT</a></li>
						<!-- DUPLICATE -->
						<li (click)="duplicateSelectedReaderInstanceClicked()" [class.disabled]="!isSingleReaderInstanceSelected()"><a><em class="fa fa-clone"></em>&nbsp;DUPLICATE</a></li>
						<!-- DELETE -->
						<li (click)="deleteSelectedReaderInstancesClicked()" [class.disabled]="!isAnyReaderInstancesSelected()" (click)="deleteSelectedReaderInstancesClicked()"><a><em class="fa fa-remove"></em>&nbsp;DELETE</a></li>
						<li class="divider"></li>
						<!-- ADD TO GROUP -->
						<li (click)="addSelectedReaderInstancesToGroupClicked()" [class.disabled]="!isAnyReaderInstancesSelected()"><a><em class="fa fa-plus"></em>&nbsp;ADD TO GROUP</a></li>
						<!-- REMOVE FROM GROUP -->
						<li (click)="removeSelectedReaderInstancesFromGroupClicked()" [class.disabled]="!isAnyReaderInstancesSelected()"><a><em class="fa fa-remove"></em>&nbsp;REMOVE FROM GROUP</a></li>
						<!-- MANAGE GROUPS -->
						<li (click)="manageReaderInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em>&nbsp;MANAGE GROUPS</a></li>
						<li class="divider"></li>
						<!-- RESET DRIVER -->
						 <li (click)="resetDriverClicked()" [class.disabled]="!isSingleReaderInstanceSelected()"><a><em class="fa fa-retweet"></em>&nbsp;RESET DRIVER</a></li>
					</ul>
				</div>

				<!-- "Filter" button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionsForInstances" (click)="onFilterOptionForInstancesClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="filterOptionForInstances?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ filterOptionForInstances.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="filterOptionForInstances?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterValueForInstances"
						(ngModelChange)="onFilterValueForInstancesChanged()">
				</div>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>


				<!-- Reader Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllReaderInstancesSelected()"
										(change)="setAllReaderInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Reader Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;" data-field="groups"
								data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader" aria-disabled="false"
								aria-controls="table1" aria-sort="none" aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner" >Status &nbsp;<em title="Refresh Status" class="fa fa-refresh" (click)="refreshPageToUpdateStatus()"></em></div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let readerInstance of mReaderInstances | paginate: {id: 'readerinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForInstances, totalItems: totalNumberOfInstances }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="readerInstance.mSelected"/></td>
								<td (click)="editReaderInstance(readerInstance.mReaderInstance)"  (contextmenu)="fetchFunctionList($event, readerInstance.mReaderInstance)">
									{{readerInstance.mReaderInstance.name}}</td>
								<td (click)="editReaderInstance(readerInstance.mReaderInstance)">
									{{readerInstance.mReaderInstance.reader.name}}</td>
								<td>
									<ng-container
										*ngIf="readerInstance.mReaderInstance.groups != null && readerInstance.mReaderInstance.groups.length > 0">
										<ng-container *ngFor="let group of readerInstance.mReaderInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
								<td >{{getReaderInstanceStatus(readerInstance.mReaderInstance)}}</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Readers" Instances (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="readerinstance_pagination"
					(pageChange)="onInstancePageChange($event)" [directionLinks]="true"
					nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance"
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	[availableLocations]="mAvailableLocations" [selectedLocation]="mSelectedLocation"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()" (selectedLocationChangedEvent)="selectedLocationChanged($event)">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- app.component.html -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog  *ngIf="showGeneralDialog" #generalDialog  [instance]="mInstance" [instanceType]="mInstanceType" [function]="selectedFunction" (functionExecutedRefreshEvent)="refreshPageToUpdateStatus()"></app-general-function-dialog>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
